import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormField } from 'src/app/shared/form/abstracts';
import { StructureField } from 'src/app/shared/incidents-reporter/interfaces';
import { IncidentsReporterSurveyForm } from 'src/app/shared/incidents-reporter/services';

@Component({
  selector: 'app-text-field-wrapper',
  standalone: true,
  imports: [
    TranslateModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: TextFieldWrapperComponent
    },
  ],
  templateUrl: './text-field-wrapper.component.html',
  styleUrls: ['./text-field-wrapper.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextFieldWrapperComponent extends BaseFormField<string> {
  // Inputs
  public field = input.required<StructureField>();
  public isTypeEmail = input<boolean>(false);
  public form = input.required<FormGroup>();
  public formControlName = input.required<string>();
  
  // Service injections
  private _cdr = inject(ChangeDetectorRef);
  private _incidentsReporterSurveyFormService = inject(IncidentsReporterSurveyForm);
  
  // Computed properties
  private _formControl = computed(() => this.form().get(this.formControlName()));
  
  // Effects
  markAllFieldsAsTouched = effect(() => {
    const control = this._formControl();
    this._markFieldsAsTouched(control, this._cdr);
  }, { allowSignalWrites: true });
  
  // Methods  
  protected handleInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (!target) return;
    
    const value = target.value;
    this._formControl().setValue(value);
  }
  
  private _markFieldsAsTouched(control: AbstractControl | null, cdr: any): void {
    if (this._incidentsReporterSurveyFormService.markAllFormFieldsAsTouched()) {
      this._incidentsReporterSurveyFormService.markFieldAsTouched(control);

      // Trigger change detection manually for OnPush (exact same as original)
      cdr.detectChanges();
    }
  }
  
  protected isInvalidField(): boolean {
    return this._incidentsReporterSurveyFormService.isInvalidField(this._formControl());
  }
}
